module.exports = __webpack_public_path__ + "eed2f85384a1674211601ebf35a9bc72.svg";